export const APP_LOADING_AUTO_LOGIN_COMPLETE = 'APP_LOADING_AUTO_LOGIN_COMPLETE';